export const DATA_LAYER_EVENT = 'submitSignupStep0';

export function postToDataLayer(data: Record<string, unknown>) {
  if (!window.dataLayer) {
    return;
  }

  window.dataLayer.push(data);
}

export function logErrorToDataLayer(errorType: string) {
  postToDataLayer({
    event: 'error',
    errorData: {
      errorType,
      url: typeof window !== 'undefined' && window.location.href,
    },
  });
}
